import { isStagingEnvironment } from "../../../util/features";

export type ConsentEnvironment = "production" | "staging";

export const CONSENT_ENVIRONMENTS: ConsentEnvironment[] = ["production", "staging"];

export const CONSENT_ENVIRONMENT_LABELS: Record<ConsentEnvironment, string> = {
  production: "Production",
  staging: "Staging",
};

/**
 * The polaris.js a customer installs on their staging site. Publishing to staging rebuilds this script only; the
 * production script is untouched.
 */
export const getStagingScriptUrl = (privacyCenterPublicId: string | undefined): string =>
  isStagingEnvironment()
    ? `https://staging.polaris.truevaultcdn.com/static/pc/${privacyCenterPublicId}/staging/polaris.js`
    : `https://polaris.truevaultcdn.com/static/pc/${privacyCenterPublicId}/staging/polaris.js`;

/**
 * We only track privacy center URLs, not the org's website. In most cases the website is the privacy center host
 * without its `privacy.` prefix, so use that when we can.
 */
export const websiteDomainFromPrivacyCenterUrl = (
  privacyCenterURL: string | undefined,
): string | null => {
  try {
    const hostname = new URL(privacyCenterURL).hostname;
    return hostname.startsWith("privacy.") ? hostname.replace("privacy.", "") : null;
  } catch (error) {
    return null;
  }
};
